export default __webpack_public_path__ + "static/media/logo1ezyfind.474b6865.png";